import { FieldValues } from 'react-hook-form';

import { issnCategoryList } from '@/module/Journal';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type IssnCategorySelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

const issnCategoryOptions = issnCategoryList.map(c => ({ value: c, label: c }));
export function IssnCategorySelectControl<T extends FieldValues>(props: IssnCategorySelectControlProps<T>) {
  return (
    <EnumSelectControl
      {...props}
      options={issnCategoryOptions}
    />
  );
}
